import {
  PREMIUM_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU_12,
  FAN_PACK_PLAN_1_MONTH_SKU,
  FAN_PACK_PLAN_12_MONTH_SKU,
  PREMIUM_PLAN_1_MONTH_SKU,
  PREMIUM_PLAN_3_MONTHS_SKU,
  PREMIUM_PLAN_12_MONTHS_SKU,
} from 'app/constants/freeTrial';

const threeTiersROW = [
  {
    sku: PREMIUM_FREE_TRIAL_SKU,
    desktopOrder: 1,
    tabletOrder: 2,
    mobileOrder: 2,
    directToPayButtonKey: 'buttons_get_premium',
    freeTrialButtonKey: 'buttons_free_trial',
    billingPeriodKey: 'landing_plans_billing_period',
    subscriptionTitleKey: 'landing_plans_fan',
    planSku: PREMIUM_PLAN_1_MONTH_SKU,
    plansToShowOnBilling: [
      PREMIUM_PLAN_1_MONTH_SKU,
      PREMIUM_PLAN_3_MONTHS_SKU,
      PREMIUM_PLAN_12_MONTHS_SKU,
    ],
    benefits: [
      {
        titleId: 'product_benefit_no_ads',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'product_benefit_unlimited_access',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'product_benefit_new_episodes',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'product_benefit_stream_on_1',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'product_benefit_store_off',
        isActive: true,
        isHidden: true,
        isVisibleOnMobile: false,
        values: {
          percent: '5',
        },
      },
      {
        titleId: 'product_benefit_offline_viewing',
        isActive: false,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_game_vault',
        isActive: false,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_16_discount',
        isActive: false,
        isVisibleOnMobile: false,
      },
    ],
  },
  {
    sku: FAN_PACK_FREE_TRIAL_SKU,
    desktopOrder: 2,
    tabletOrder: 1,
    mobileOrder: 1,
    isMostPopular: true,
    directToPayButtonKey: 'buttons_get_premium',
    freeTrialButtonKey: 'buttons_free_trial',
    billingPeriodKey: 'landing_plans_billing_period',
    subscriptionTitleKey: 'landing_plans_mega_fan',
    durationKey: 'product_duration_1',
    planSku: FAN_PACK_PLAN_1_MONTH_SKU,
    plansToShowOnBilling: [FAN_PACK_PLAN_1_MONTH_SKU],
    prevProductTitleKey: 'landing_plans_fan',
    benefits: [
      {
        titleId: 'product_benefit_no_ads',
        isActive: true,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_unlimited_access',
        isActive: true,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_new_episodes',
        isActive: true,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_stream_on_4',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'product_benefit_offline_viewing',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'product_benefit_game_vault',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'product_benefit_store_off',
        isActive: true,
        isVisibleOnMobile: true,
        isHidden: true,
        values: {
          percent: '10',
        },
      },
      {
        titleId: 'product_benefit_16_discount',
        isActive: false,
        isVisibleOnMobile: false,
      },
    ],
  },
  {
    sku: FAN_PACK_FREE_TRIAL_SKU_12,
    desktopOrder: 3,
    tabletOrder: 3,
    mobileOrder: 3,
    directToPayButtonKey: 'buttons_get_premium',
    freeTrialButtonKey: 'buttons_free_trial',
    savingsSummaryKey: 'landing_product_savings_summary',
    billingPeriodKey: 'product_billing_period_anual',
    subscriptionTitleKey: 'landing_plans_mega_fan',
    durationKey: 'product_duration_12',
    prevProductTitleKey: 'landing_plans_mega_fan',
    planSku: FAN_PACK_PLAN_12_MONTH_SKU,
    plansToShowOnBilling: [FAN_PACK_PLAN_12_MONTH_SKU],
    benefits: [
      {
        titleId: 'product_benefit_no_ads',
        isActive: true,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_unlimited_access',
        isActive: true,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_new_episodes',
        isActive: true,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_stream_on_4',
        isActive: true,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_offline_viewing',
        isActive: true,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_game_vault',
        isActive: true,
        isVisibleOnMobile: false,
      },
      {
        titleId: 'product_benefit_store_off',
        isActive: true,
        isVisibleOnMobile: true,
        isHidden: true,
        values: {
          percent: '10',
        },
      },
      {
        titleId: 'product_benefit_16_discount',
        isActive: true,
        isVisibleOnMobile: true,
      },
    ],
  },
];

export default threeTiersROW;
